import React from "react"
import CCMViewQuestion from "./Component/CCMViewQuestion/CCMViewQuestion"
// import CCMAdminPatient from "../CCMAdminPatient/CCMAdminPatient"

const CCMViewCare = () => <CCMViewQuestion />

export default CCMViewCare
